module.exports = __webpack_public_path__ + "static/media/psychological-first-aid.38f004a7.svg";